/**
 * @desc 分页
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.mskuMap.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
